import { t } from "../../../i18n/translate";
import { ButtonDefault } from "../button-default/ButtonDefault";
import { buttonVariants } from "../button-default/buttonVariants";

type ButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isFullscreen: boolean;
};

export function ButtonFullscreen({ onClick, isFullscreen }: ButtonProps) {
  return (
    <ButtonDefault
      onClick={onClick}
      variant={buttonVariants.icon}
      className={isFullscreen ? "active" : ""}
      title={isFullscreen ? t("salir_pantalla_completa") : t("pantalla_completa")}
    >
      {isFullscreen ? <ExitFullscreenIcon /> : <EnterFullscreenIcon />}
    </ButtonDefault>
  );
}

function EnterFullscreenIcon() {
  return (
    <svg width="20px" height="20px" viewBox="0 0 20 20" aria-hidden>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g className="svg-icon-fill">
          <path d="M0 0h8v2H2v6H0V0z" />
          <path d="M12 0h8v8h-2V2h-6V0z" />
          <path d="M0 12h2v6h6v2H0v-8z" />
          <path d="M18 12h2v8h-8v-2h6v-6z" />
        </g>
      </g>
    </svg>
  );
}

function ExitFullscreenIcon() {
  return (
    <svg width="20px" height="20px" viewBox="0 0 20 20" aria-hidden>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g className="svg-icon-fill">
          <path d="M0 0h6v2H2v4H0V0z" />
          <path d="M14 0h6v6h-2V2h-4V0z" />
          <path d="M0 14h2v4h4v2H0v-6z" />
          <path d="M18 14h2v6h-6v-2h4v-4z" />
        </g>
      </g>
    </svg>
  );
}
